import React, { Fragment } from 'react';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatDateDefault } from 'services/DateFormatters';
import { TIGHT_FIT_PARAM } from 'constants/System';

class ProjectTable extends React.Component {
    constructor(props) {
        super(props);
        const { selected } = props;
        this.state = {
            selected
        };
    }
    render() {
        const { data, width, setProject } = this.props;
        const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;
        // const smallWidth = width > TIGHT_FIT_PARAM ? 30 : 30; // TODO see how this works
        const styledSummaryColumn = (value) => {
            return <Fragment>
                <span className="d-inline-block text-black">
                    <div className="font-weight-bold">{value}</div>
                </span>
            </Fragment>;
        };
        const weightColumn = {
            Header: 'Weight',
            id: 'weight',
            accessor: d => d?.weight || 0,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['weight'] }),
            filterAll: true,
            width: 50,
        };
        const summaryColumn = {
            Header: 'Name',
            id: 'name',
            accessor: d => d?.name,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['name'] }),
            Cell: ({ value }) => {
                return styledSummaryColumn(value);
            },
            filterAll: true,
        };
        const createdColumn = {
            Header: 'Start Date',
            id: 'startDate',
            accessor: d => d?.startDate,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['startDate'] }),
            filterAll: true,
            Cell: ({ value }) => {
                return formatDateDefault(value);
            },
            width: defaultWidth,
        };
        const resolvedColumn = {
            Header: 'End Date',
            id: 'endDate',
            accessor: d => d?.endDate,
            filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ['endDate'] }),
            filterAll: true,
            Cell: ({ value }) => {
                return formatDateDefault(value);
            },
            width: defaultWidth,
        };
        const columnsList = new Array();
        columnsList.push(summaryColumn);
        columnsList.push(weightColumn);
        columnsList.push(createdColumn);
        columnsList.push(resolvedColumn);
        return (
            <div>
                <ReactTable
                    data={data}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                        {
                            columns: columnsList
                        }
                    ]}
                    defaultPageSize={data?.length <= 5 ? 5 : 10}
                    className='-highlight'
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    console.log(JSON.stringify(rowInfo?.index));
                                    setProject(rowInfo?.original?.id);
                                    this.setState({
                                        selected: rowInfo.index
                                    });
                                },
                                style: {
                                    background: rowInfo.index === this.state.selected ? '#cfd8dc' : 'white',
                                    color: rowInfo.index === this.state.selected ? 'black' : 'black'
                                }
                            };
                        } else {
                            return {};
                        }
                    }}
                />
            </div>
        );
    }
}

export default ProjectTable;


// WEBPACK FOOTER //
// ./components/Agile/project/projectList/projectTable/index.js